export default __webpack_public_path__ + "static/024-f7f2d36282995c9a0009d3dcbe5aab4c.jpg";